import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SweetAlertService {

  showSuccess(options: {
    title: string;
    text?: string;
    html?: string;
    confirmButtonText?: string;
  }): Promise<boolean> {
    return Swal.fire({
      icon: 'success',
      title: options.title,
      html: options.html ?? options.text ?? '',
      confirmButtonText: options.confirmButtonText || 'Aceptar'
    }).then(result => result.isConfirmed);
  }

  showError(options: {
    title: string;
    text?: string;
    html?: string;
    confirmButtonText?: string;
  }): Promise<boolean> {
    return Swal.fire({
      icon: 'error',
      title: options.title,
      html: options.html ?? options.text ?? '',
      confirmButtonText: options.confirmButtonText || 'Aceptar',
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then(result => result.isConfirmed);
  }

  showToast(options: {
    title: string;
    text?: string;
    timer?: number;
  }): void {
    Swal.fire({
      icon: 'info',
      title: options.title,
      text: options.text,
      timer: options.timer ?? 2500,
      timerProgressBar: true,
      showConfirmButton: false,
      toast: true,
      position: 'top'
    });
  }

  showBlocker(options: {
    title: string;
    text?: string;
    html?: string;
  }): void {
    Swal.fire({
      icon: 'error',
      title: options.title,
      html: options.html ?? options.text ?? '',
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: false
    });
  }

  showConfirmation(options: {
    title: string;
    text?: string;
    html?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
  }): Promise<boolean> {
    return Swal.fire({
      icon: 'warning',
      title: options.title,
      html: options.html ?? options.text ?? '',
      showCancelButton: true,
      confirmButtonText: options.confirmButtonText || 'Sí',
      cancelButtonText: options.cancelButtonText || 'Cancelar',
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then(result => result.isConfirmed);
  }
}